import { useState } from 'react'
import './home.css'
import { Link, useNavigate } from 'react-router-dom'

import { auth } from "../../firebaseConnection"
import { signInWithEmailAndPassword } from 'firebase/auth'

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export default function Home(){
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const navigate = useNavigate();

  async function handleLogin(e){
    e.preventDefault()

    if(email !== "" && password !== ""){
      await signInWithEmailAndPassword(auth, email, password)
      .then(() => {
        toast.success('Login realizado com sucesso!')
        navigate('/admin', { replace: true })
      })
      .catch((error) => {
        toast.error('Erro ao fazer login. Verifique seus dados!')
        console.error(error)
      })
    } else {
      toast.warn('Preencha todos os campos!')
    }
  }

  return(
    <div className="home-container">
      <ToastContainer />
      <h1>Tarefas Web</h1>
      <span className='acessar'>Faça login para Acessar</span>

      <form className='form' onSubmit={handleLogin}>
        <input 
          type="email" 
          placeholder='Digite seu email...'
          value={email}
          onChange={(e)=> setEmail(e.target.value)}
        />
        <input 
          type="password" 
          placeholder='************'
          value={password}
          onChange={(e)=> setPassword(e.target.value)}
        />
        <button type='submit'>Acessar</button>
      </form>

      <Link className="button-link" to="/register">
        Não possui uma conta? Cadastre-se!
      </Link>
    </div>
  )
}
